import { View, Text, Link } from '@/components'
import { StylesOf } from '@codeleap/common'
import { FooterComposition } from '../../../app/stylesheets/Footer'

export type FooterNavigateProps = {
  variantStyles?: StylesOf<FooterComposition>
}

type NavigateLink = {
  text: string
  route?: AppRoute
  to?: string
}

const links: Record<string, NavigateLink[]> = {
  pages: [
    { text: 'Home', route: 'Home' },
    { text: 'Playground', route: 'Playground' },
  ],
  others: [
    { text: 'About', route: 'About' },
    { text: 'Docs', to: 'http://docs.codeleap.co.uk/' }
  ]
}

function Column({ links, title, variantStyles }) {
  const renderLink = (link, index) => (
    <Link
      key={index + 'footer-link'}
      route={link?.route}
      to={link?.to}
      openNewTab={!!link?.to}
      text={link?.text}
      css={variantStyles.navigateLink}
    />
  )

  return (
    <View css={variantStyles.navigateColumn}>
      <Text css={variantStyles.navigateTitle} text={title} />
      {links.map(renderLink)}
    </View>
  )
}

export const FooterNavigate = (props: FooterNavigateProps) => {
  const { variantStyles } = props

  return (
    <View css={variantStyles.navigateWrapper}>
      <Column
        variantStyles={variantStyles}
        title={'Pages'}
        links={links?.pages}
      />
      <Column
        variantStyles={variantStyles}
        title='Terms & Conditions'
        links={links?.others}
      />
    </View>
  )
}
